import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ 
  title, 
  value, 
  icon, 
  trend, 
  trendValue, 
  iconBgColor = 'bg-secondary' 
}) => {
  const isPositiveTrend = trend === 'up';
  
  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 smooth-transition hover-lift shadow-warm-sm">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl font-semibold data-text">{value}</h3>
        </div>
        <div className={`${iconBgColor} rounded-lg p-2 md:p-3 flex-shrink-0`}>
          <Icon name={icon} size={20} color="var(--color-primary)" />
        </div>
      </div>
      
      {trend && (
        <div className="flex items-center gap-1">
          <Icon 
            name={isPositiveTrend ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            color={isPositiveTrend ? 'var(--color-success)' : 'var(--color-error)'} 
          />
          <span className={`text-xs data-text ${isPositiveTrend ? 'text-success' : 'text-error'}`}>
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground ml-1">vs last month</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;